export const en = {
    amount_placeholder: 'Specify the deposit amount',
    balance_invoice: 'Account refill',
    balance_invoice_description: 'After entering the deposit amount, an invoice will be generated, which you need to download and pay for.',
    invoice_download_description: 'You can download the invoice and pay it.',
    digits_only: 'Incorrect value entered',
};
